var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalAttendee = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 14,
  fill: "none",
  viewBox: "0 0 10 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#9CA1AF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M1 13v-1.333A2.667 2.667 0 0 1 3.667 9h2.666A2.667 2.667 0 0 1 9 11.667V13M2.333 3.667a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0"
})));
export default SvgExternalAttendee;